import React from "react";
import { Map } from "immutable";
import T from "prop-types";
import { Link } from "react-router-dom";
import SellableQty from "MODULES/parts/components/shared/SellableQty";
import { ClipboardCopy, PartStatsTooltip } from "MODULES/shared/components";
import classNames from "classnames";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import {
  DESCRIPTION,
  PART_NUMBER,
  SELLABLE_QUANTITIES,
  TIER_TYPE
} from "MODULES/parts/constants";
import { UUID } from "APP_ROOT/constants";

export default function BackToPart({ part }) {
  const classes = classNames(
    getPartNumberColorClassNameByTierType(part.get(TIER_TYPE))
  );
  return (
    <div className="page-header page-header-bar">
      <h1>
        <div className="with-padding">
          <Link to={`/parts/${part.get(UUID)}`}>
            <i className="fa fa-long-arrow-left" />
            &nbsp;<span className={classes}>{part.get(PART_NUMBER)}</span>&nbsp;
          </Link>
          <ClipboardCopy name={part.get(PART_NUMBER)} type="PN" />
          <span className="small text-muted">{part.get(DESCRIPTION)}</span>
          <PartStatsTooltip part={part.toJS()} />
          <SellableQty quantities={part.get(SELLABLE_QUANTITIES)} />
        </div>
      </h1>
    </div>
  );
}

BackToPart.propTypes = {
  part: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/BackToPart.jsx